// Brand marks for the wrap simulator's brand bar, drawn as inline SVG wordmarks in each brand's livery (no external assets).
const T = ({ x, y, size, weight = 900, fill = "#fff", italic, spacing = 0, children, family }) => (
  <text x={x} y={y} fontSize={size} fontWeight={weight} fill={fill} fontStyle={italic ? "italic" : undefined} letterSpacing={spacing} fontFamily={family || "'IBM Plex Sans', 'Segoe UI', Arial, sans-serif"}>{children}</text>
);

const MARKS = {
  "3m": (
    <svg viewBox="0 0 170 36" className="h-7">
      <T x={0} y={29} size={32} fill="#ff1f1f" weight={900} spacing={-2}>3M</T>
      <rect x={58} y={5} width={1.5} height={26} fill="rgba(255,255,255,.55)" />
      <T x={67} y={27} size={20} weight={600}>Wrap Film</T>
    </svg>
  ),
  avery: (
    <svg viewBox="0 0 190 36" className="h-7">
      <path d="M17 3 L32 31 H2 Z M17 12 L25 27 H9 Z" fill="#e23b2e" fillRule="evenodd" />
      <path d="M17 17 L21 25 H13 Z" fill="#e23b2e" />
      <T x={40} y={17} size={13} fill="#e23b2e" weight={800} spacing={0.5}>AVERY</T>
      <T x={40} y={31} size={13} fill="#e23b2e" weight={800} spacing={0.5}>DENNISON</T>
    </svg>
  ),
  kpmf: (
    <svg viewBox="0 0 96 36" className="h-7">
      <rect x={1} y={4} width={94} height={28} rx={3} fill="#dfe6ee" stroke="#9aa6b4" strokeWidth={1.5} />
      <rect x={5} y={8} width={86} height={20} rx={2} fill="none" stroke="#6b7a8c" strokeWidth={1} />
      <T x={10} y={25} size={19} fill="#1a3a66" weight={900} italic family="Georgia, 'Times New Roman', serif">KPMF</T>
    </svg>
  ),
  teckwrap: (
    <svg viewBox="0 0 186 36" className="h-7">
      <path d="M2 8 H34 V15 H22 V30 H14 V15 H2 Z" fill="#fff" />
      <T x={30} y={28} size={21} weight={900} italic spacing={1.5}>ECKWRAP</T>
    </svg>
  ),
  xpel: (
    <svg viewBox="0 0 150 36" className="h-7">
      <circle cx={6} cy={19} r={2.2} fill="#fff" opacity={0.6} /><circle cx={14} cy={19} r={2.6} fill="#fff" opacity={0.8} /><circle cx={23} cy={19} r={3} fill="#fff" />
      <T x={32} y={30} size={30} weight={900} italic spacing={-1}>XPEL</T>
    </svg>
  ),
  pureppf: (
    <svg viewBox="0 0 170 36" className="h-7">
      <path d="M16 3 L28 7 V18 C28 26 22 31 16 34 C10 31 4 26 4 18 V7 Z" fill="#fff" />
      <path d="M16 8 L23 10.5 V18 C23 23 19.5 26.5 16 28.5 C12.5 26.5 9 23 9 18 V10.5 Z" fill="#0d1218" />
      <path d="M12 18 L15 21 L21 14" stroke="#fff" strokeWidth={2.2} fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <T x={36} y={29} size={23} weight={900} spacing={0.5}>PURE</T>
      <T x={104} y={29} size={23} weight={600} fill="rgba(255,255,255,.55)" spacing={0.5}>PPF</T>
    </svg>
  ),
};

export const BrandMark = ({ id, name }) => MARKS[id] || <span className="text-[17px] font-black text-white">{name}</span>;
